module.exports = __webpack_public_path__ + "img/gls-logo.1d0c3b1c.png";